// export const BASE_URL = "http://localhost:8080/lhb-core";
//site key for google captcha
// export const REACT_APP_SITE_KEY = "6LegAzwtAAAAALjgF9b9OuB-mVrxaYhQvdJ0Xv_Q";
//staging url
// export const BASE_URL = "https://api.scalent.in/lhb-core";

//prod URL
export const BASE_URL = "https://lhbapi.raychemrpg.com/lhb-core";

// login API
export const LOGIN = `${BASE_URL}/login`;

// logout API
export const LOGOUT = `${BASE_URL}/logout`;

//timesheet lhb records
export const TIMESHEET_LHB_RECORDS = `${BASE_URL}/timesheet/`;
export const TIMESHEET_LHB_RECORDS_LIST = `${BASE_URL}/timesheet/list`;

//lhb records
export const LHB_RECORDS = `${BASE_URL}/lhb-record`;

//duty type
export const DUTY_TYPE_LIST = `${BASE_URL}/duty-type/list`;

//shift
export const SHIFT_LIST = `${BASE_URL}/shift/list`;

//product
export const PRODUCT_LIST = `${BASE_URL}/product/list`;

//project
export const PROJECT_LIST = `${BASE_URL}/project/list`;

//unit
export const UNIT_LIST = `${BASE_URL}/unit/list`;

//station
export const STATION_LIST = `${BASE_URL}/station/list`;

//subactivity
export const SUBACTIVITY_LIST = `${BASE_URL}/sub-activity/list`;

//micro activity
export const MICROACTIVITY_LIST = `${BASE_URL}/micro-activity/list`;

//remark
export const REMARK_LIST = `${BASE_URL}/remark/list`;

//lhb records
export const LHBRECORDS_LIST = `${BASE_URL}/timesheet/lhb/list`;
